import { Navigate } from 'react-router';

import { ANY_SPORT_PLAY_BOARDS_ARENA_ARENAMODE } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import { Mode } from '#src/components/pickers/ModePicker/index.tsx';
import { useLastVisitedBoardView } from '#src/hooks/useLastVisitedBoardView.ts';
import { modeToArenaMode } from '#src/lib/arenaMode.ts';

const BoardsArenaPage = () => {
  const { generateSportContextPath } = useSportContext();
  const { lastVisitedView } = useLastVisitedBoardView();

  const arenaMode = modeToArenaMode(
    lastVisitedView?.lastVisitedMode ?? Mode.ARENA_CASH
  );

  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_PLAY_BOARDS_ARENA_ARENAMODE, {
        params: { arenaMode },
      })}
      replace
    />
  );
};

export default BoardsArenaPage;
